import * as React from 'react';

import {OptionCardChooser} from 'shells/option-card-chooser/option-card-chooser';

import {RECIPIENT_TYPE_AUDIENCE, RECIPIENT_TYPE_SAVED_LIST} from './new-recipients-selection-view';

import styles from './new-recipients-selection-view.module.css';

type Props = {
    onSelect: (recipientType: 'list' | 'audience') => void;
    canAccessAudiences: boolean;
    currentSelection: 'list' | 'audience' | null | undefined;
};

export function ChooseRecipientType(props: Props) {
    const AUDIENCE_SELECTION = (
        <OptionCardChooser
            key='audience'
            title='An audience'
            subtitle='Targeted lists of individuals'
            illustration='audience-group'
            onClick={() => {
                props.onSelect(RECIPIENT_TYPE_AUDIENCE);
            }}
            isSelected={Boolean(props.currentSelection === RECIPIENT_TYPE_AUDIENCE)}
        />
    );

    const LIST_SELECTION = (
        <OptionCardChooser
            key='list'
            title='A saved list'
            subtitle='Filtered lists that update in real-time'
            illustration='saved-list'
            onClick={() => {
                props.onSelect(RECIPIENT_TYPE_SAVED_LIST);
            }}
            isSelected={Boolean(props.currentSelection === RECIPIENT_TYPE_SAVED_LIST)}
        />
    );

    return (
        <div className={styles['left-container']}>
            <div className={styles['grid-container']}>
                {/* If no access to audiences, swap the order of the options */}
                {props.canAccessAudiences
                    ? [AUDIENCE_SELECTION, LIST_SELECTION]
                    : [LIST_SELECTION, AUDIENCE_SELECTION]}
            </div>
        </div>
    );
}
